import type { ObjectValues } from '@repo/common';

export const AppStateActionType = {
  SET_STEP: 'SET_STEP',
  SET_PREV_STEP: 'SET_PREV_STEP',
  SET_FIRST_STEP: 'SET_FIRST_STEP',
  SET_WORKFLOW: 'SET_WORKFLOW',
  TOGGLE_INFO_MODAL: 'TOGGLE_INFO_MODAL',
  SET_CUSTOMER_DATA: 'SET_CUSTOMER_DATA',
  SET_VIEW_TYPE: 'SET_VIEW_TYPE',
  SET_VERIFICATION_RESULT: 'SET_VERIFICATION_RESULT',
  SET_VERIFICATION_ON_MOBILE: 'SET_VERIFICATION_ON_MOBILE',
  SET_CUSTOM_FLOW_TYPE: 'SET_CUSTOM_FLOW_TYPE',
  SET_ALTERNATE_STEP: 'SET_ALTERNATE_STEP',
  SET_STEP_DATA: 'SET_STEP_DATA',
  SET_SUBMIT_ERROR_CONTEXT: 'SET_SUBMIT_ERROR_CONTEXT',
} as const;

export type AppStateActionTypeValues = ObjectValues<typeof AppStateActionType>;
